import { render, staticRenderFns } from "./SendDeal.vue?vue&type=template&id=2e89f31b&scoped=true"
import script from "./SendDeal.vue?vue&type=script&lang=js"
export * from "./SendDeal.vue?vue&type=script&lang=js"
import style0 from "./SendDeal.vue?vue&type=style&index=0&id=2e89f31b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e89f31b",
  null
  
)

export default component.exports